<template>
    <div class="reportForms">
        <div class="reportFormsBtn">
            <div class="btnView">
                <div class="btnItem" :class="activeIndex === 0 ? 'active' : ''" @click="onTab(0)">总报表</div>
                <div class="btnItem" :class="activeIndex === 1 ? 'active' : ''" @click="onTab(1)">月报表</div>
            </div>

        </div>
        <div class="reportFormsContent">
            <div class="selectTimeView" v-if="activeIndex === 1" @click="showDate = true">{{ date ? getTimes(date *
                1000,
                'YYYY-MM') : '选择-年-月' }}</div>
            <totalForm v-if="activeIndex === 0" />
            <monthForm v-if="activeIndex === 1" :date="date.toString()" />
            <TabBar :activeIndex="1" />
            <popup v-model="showDate" position="bottom">
                <DatetimePicker v-model="currentDate" type="year-month" title="选择年月" @confirm="confirmDate"
                    @cancel="showDate = false" :min-date="minDate" :max-date="maxDate" />
            </popup>
        </div>
    </div>
</template>

<script>
/*
* 统计
* */
import TabBar from '../../components/TabBar'
import totalForm from "./totalForm";
import monthForm from "./monthForm";
import { Popup, DatetimePicker } from 'vant';

export default {
    name: "reportForms",
    components: {
        TabBar, totalForm, monthForm, Popup, DatetimePicker
    },
    data() {
        return {
            activeIndex: 0,
            showDate: false,
            currentDate: new Date(),
            date: '',
            minDate: new Date(2000, 0, 1),
            maxDate: new Date(2099, 11, 1),
        }
    },
    methods: {
        onTab(index) {
            this.activeIndex = index;
        },
        confirmDate(date) {
            this.date = new Date(date).getTime() / 1000;
            this.showDate = false;
        }
    }
}
</script>

<style lang='less' scoped>
.reportForms {
    min-height: 100vh;

    background-color: #f8f8f8;


    .reportFormsBtn {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 9.47vw;
        padding: 3.2vw;
        background-color: #ffffff;
        box-shadow: 0 0.53vw 1.33vw -0.53vw rgba(0, 0, 0, 0.08);
        border-radius: 1.2vw;
        // box-sizing: border-box;

        .btnView {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            border-radius: 1.2vw;
            overflow: hidden;
        }

        .btnItem {
            line-height: 9.47vw;
            font-size: 3.2vw;
            color: #666;
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #f0f2f5;

            &.active {
                position: relative;
                background-color: #43a2fe;
                color: #ffffff;
            }
        }


    }

    .reportFormsContent {
        padding: 3vw 3vw 50px 3vw;
        box-sizing: border-box;

        .selectTimeView {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 10.07vw;
            padding-left: 3.2vw;
            box-sizing: border-box;
            background-color: #ffffff;
            border-radius: 1.2vw;
            font-size: 3.67vw;
            color: #171b18;
        }
    }


}
</style>



// WEBPACK FOOTER //
// src/page/reportForms/index.vue